import type { SchrijvenTopic } from "./types";
import { EXAMEN_OVERZICHT } from "./examen-overzicht";

/** Registry of Schrijven study topics. Order here = order on the index page. */
export const SCHRIJVEN_TOPICS: readonly SchrijvenTopic[] = [EXAMEN_OVERZICHT] as const;

export function getSchrijvenTopicBySlug(slug: string): SchrijvenTopic | undefined {
  return SCHRIJVEN_TOPICS.find((t) => t.slug === slug);
}

export function listSchrijvenTopics(): readonly SchrijvenTopic[] {
  return SCHRIJVEN_TOPICS;
}
